
// This file is generated by the maven plugin com.axley.js-remodel.  Do not edit!!!

import { GenLegend } from './GenLegend';
import { GenPopover } from './GenPopover';
import { GenServiceType } from './GenServiceType';

export class GenMapLayer {

    id: number;
    active: boolean;
    attributionTitle: string;
    attributionUrl: string;
    defaultActive: boolean;
    description: string;
    displayName: string;
    layerGroupId: number;
    legend: GenLegend;
    ordering: number;
    params: string;
    popoverData: GenPopover[];
    serviceLayer: string;
    serviceType: GenServiceType;
    serviceUrl: string;
    uiHandle: string;

    constructor();
    constructor( jsonObj: any );
    constructor( genMapLayer: GenMapLayer);
    constructor( id: number );

    constructor( input?: GenMapLayer|number ) {
        if ( typeof input === 'number') {
            this.id = input;
        }

        if ( input && typeof input !== 'number' ) {
            this.id = input.id; // int [number]
            this.active = input.active; // boolean [boolean]
            this.attributionTitle = input.attributionTitle; // string [string]
            this.attributionUrl = input.attributionUrl; // string [string]
            this.defaultActive = input.defaultActive; // boolean [boolean]
            this.description = input.description; // string [string]
            this.displayName = input.displayName; // string [string]
            this.layerGroupId = input.layerGroupId; // int [number]
            if( input.legend ) {
              this.legend = new GenLegend( input.legend );
            }
            this.ordering = input.ordering; // int [number]
            this.params = input.params; // string [string]
            if ( input.popoverData && input.popoverData.map ) { // list [GenPopover]
                this.popoverData = input.popoverData.map( ( x: GenPopover ) => {
                    return new GenPopover( x );
                } );
            } else {
                this.popoverData = input.popoverData;
            }
            this.serviceLayer = input.serviceLayer; // string [string]
            this.serviceType = (typeof input.serviceType === 'string') ? GenServiceType.forName(<string> input.serviceType) : <any> input.serviceType; // GenServiceType
            this.serviceUrl = input.serviceUrl; // string [string]
            this.uiHandle = input.uiHandle; // string [string]
       }
    }

    static jsonResponseToList(arr: any[]): GenMapLayer[] {
        if (arr && arr.map) {
          return arr.map(a => new GenMapLayer(a));
        } else {
          return [];
        }
    }
}

